import { Alert, Text } from "@vericus/cadmus-ui";

import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";

import { DialoguePanel } from "@/features/socratic/components/dialogue-panel";
import {
  AnswerBlockFragment,
  SocraticDialogueFragment,
} from "@/generated/graphql";

import * as styles from "./socratic-dialogue.css";

interface Props {
  otherDialogue: SocraticDialogueFragment;
  answerBlock: AnswerBlockFragment;
}

/**
 * Recovery is shown if the student loses their attempt due to refreshing the page
 */
export function RecoveryScreen(props: Props) {
  const { otherDialogue, answerBlock } = props;

  const { responseTimeSeconds } = otherDialogue;

  // TODO: Handle case where there are no turns
  const [firstTurn] = otherDialogue.turns;
  if (!firstTurn) return null;

  return (
    <PanelGroup direction="horizontal" className={styles.content}>
      <Panel
        id="recovery-dialogue-panel"
        order={1}
        defaultSize={34}
        minSize={20}
        maxSize={50}
      >
        <DialoguePanel
          answerBlock={answerBlock}
          turn={firstTurn}
          responseTimeSeconds={responseTimeSeconds}
        />
      </Panel>

      <PanelResizeHandle className={styles.handle} />

      <Panel id="recovery-main" order={2}>
        <div className={styles.main}>
          <div className={styles.webcamContainer()}>
            <BlackBox />
          </div>
          <Alert title="Something went wrong" className={styles.contentColumn}>
            You got disconnected, and we couldn’t complete your recording.
            Please contact your instructor for help
          </Alert>
        </div>
      </Panel>
    </PanelGroup>
  );
}

const BlackBox = () => {
  return (
    <div className={styles.recovery.blackBox}>
      <div className={styles.recovery.oopsContainer}>
        <Text className={styles.recovery.oopsText} kind="displayTwo">
          Oops, we ran into a problem
        </Text>
      </div>
    </div>
  );
};
